// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"296b4a7c","351":"019b4575","380":"bc7f813d","455":"399606b7","499":"eeb6d839","728":"ad705ef7","797":"16a6b632","852":"efabf713","936":"313b8e5e","974":"799586b5","977":"8c72bf08"}[chunkId] + ".chunk.js";
};